import apiClient from '../lib/apiClient';

const clientCodeSettingsService = {
    // Get current client code settings
    getSettings: async () => {
        try {
            const result = await apiClient.get('/client-code-settings');
            return result;
        } catch (error) {
            return {
                success: false,
                error: error.message || 'Failed to fetch settings'
            };
        }
    },

    // Update client code settings
    updateSettings: async (settings) => {
        try {
            const result = await apiClient.put('/client-code-settings', settings);
            return result;
        } catch (error) {
            return {
                success: false,
                error: error.message || 'Failed to update settings'
            };
        }
    },

    // Preview next client code
    previewNextCode: async () => {
        try {
            const result = await apiClient.get('/client-code-settings/preview');
            return result;
        } catch (error) {
            return {
                success: false,
                error: error.message || 'Failed to preview code'
            };
        }
    }
};

export default clientCodeSettingsService;
